import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Contracts list (CLAUDE.md §2.3).
 *
 * Search / status filter live in page state and stay out of the store — those
 * are server-driven query params, not durable user prefs.
 */
export type ContractsViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const CONTRACTS_VIEW_MODES: ContractsViewMode[] = ['table', 'list', 'cards', 'grouped'];

interface ContractsUiState {
  view: ContractsViewMode;
  setView: (view: ContractsViewMode) => void;
  /** Transient toggle — refreshes default to the active list. */
  showArchived: boolean;
  setShowArchived: (showArchived: boolean) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-created`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useContractsUi = create<ContractsUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      showArchived: false,
      setShowArchived: (showArchived) => set({ showArchived }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'crm.contracts:ui',
      partialize: (s) => ({ view: s.view }),
    },
  ),
);
